import React from 'react';
import KbHome from './kb-home';
import { KbHomePage } from '../../../content/types/content/kb-home';

export default function renderKbHome(entry: KbHomePage) {
    return <KbHome entry={entry} />;
}
